import { handleActions } from 'redux-actions';
import { formFindersLoaded, formFinderSelect } from '../actions';

const initialState = {
    existing: [],
    selected: {},
};

export default handleActions(
    {
        [formFindersLoaded]: (state, action) => ({
            ...state,
            existing: action.payload,
        }),
        [formFinderSelect]: (state, action) => ({
            ...state,
            selected: action.payload,
        }),
    },
    initialState,
);
